import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario.js';
import './creaInstancia.css';
import Swal from 'sweetalert2';

const CreaInstancia = (props) => {
  const [cursosDisponibles, setCursosDisponibles] = useState(null);
  const [escuelaSeleccionada, setEscuelaSeleccionada] = useState(null);
  const [escuelasDisponibles, setEscuelasDisponibles] = useState([]);
  const Usuario = ObtieneDatosCookies();

const [esFinalExclusiva, setEsFinalExclusiva] = useState(false);
  const [selectedCurso, setSelectedCurso] = useState('');
  const [nombreCurso, setSelectedNombreCurso] = useState('');
  const [nombreInstancia, setNombreInstancia] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFinal, setFechaFinal] = useState('');
  const [fechaError, setFechaError] = useState('');
  const [estado, setEstado] = useState(true);
const [estadoInicialInstancia, setEstadoInicialIntancia] = useState('Activo');
  const [tipoInstancia, setTipoInstancia] = useState('Regular');
  const [tipoCalificacion, setTipoCalificacion] = useState('Numerica');

  const [materiasDisponibles, setMateriasDisponibles] = useState([]);
  const [materiasSeleccionadas, setMateriasSeleccionadas] = useState([]);
  const [dnisPorMateria, setDnisPorMateria] = useState({});

  const normalizarDnis = (texto = '') => {
    return texto
      .split(/[\s,;]+/)
      .map((dni) => dni.trim())
      .filter((dni) => dni);
  };

  const textoDnisNormalizado = (texto = '') => {
    return normalizarDnis(texto).join(', ');
  };

  useEffect(() => {
    const Usuario = ObtieneDatosCookies();
    const textoFuncion = Usuario.funcion || '';

    const palabrasClave = [
      'Escuela de Policia',
      'Escuela de Especialidades',
      'Escuela Superior',
      'Escuela de Investigaciones',
      'Educacion a Distancia',
      'Extracurricular',
      'Extension Comunitaria'
    ];

    const escuelasEncontradas = palabrasClave.filter((clave) =>
      textoFuncion.includes(clave)
    );

    if (Usuario.destino == 1 || Usuario.destino == 7) {
      setEscuelasDisponibles(['Todo', ...escuelasEncontradas]);
      setEscuelaSeleccionada('Todo');
    } else if (escuelasEncontradas.length > 1) {
      setEscuelasDisponibles(escuelasEncontradas);
      setEscuelaSeleccionada(escuelasEncontradas[0]);
    } else if (escuelasEncontradas.length === 1) {
      setEscuelasDisponibles(escuelasEncontradas);
      setEscuelaSeleccionada(escuelasEncontradas[0]);
    } else {
      setEscuelasDisponibles(['Escuela de Policia']);
      setEscuelaSeleccionada('Escuela de Policia');
    }
  }, []);

  useEffect(() => {
    if (!escuelaSeleccionada) return;

    const url =
      escuelaSeleccionada === 'Todo'
        ? 'https://wwwa.isepsantafe.net.ar/expedientes/cursos/devuelveCursosPorEscuela/Todo'
        : 'https://wwwa.isepsantafe.net.ar/expedientes/cursos/devuelveCursosPorEscuela/' +
          encodeURIComponent(escuelaSeleccionada);

    axios
      .post(url, { estadoCurso: 'Activo' })
      .then((response) => {
        setCursosDisponibles(
          response.data.Cursos.sort((a, b) =>
            a.nombreCurso.localeCompare(b.nombreCurso)
          )
        );
      })
      .catch((error) => {
        console.error('Error fetching cursos:', error);
      });
  }, [escuelaSeleccionada]);

  const handleSelectChange = (event) => {
    const cursoId = event.target.value;
    setSelectedCurso(cursoId);
    setSelectedNombreCurso(
      cursosDisponibles.find((id) => id.id == cursoId)?.nombreCurso || ''
    );

    setMateriasSeleccionadas([]);
    setDnisPorMateria({});
  };

  useEffect(() => {
    if (tipoInstancia === 'Exclusiva' && nombreCurso) {
      axios
        .post(
          'https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveMateriasPorCurso',
          { curso: nombreCurso }
        )
        .then((res) => {
          setMateriasDisponibles(res.data.materias || []);
        })
        .catch((err) => console.error('Error obteniendo materias:', err));
    } else {
      setMateriasDisponibles([]);
      setMateriasSeleccionadas([]);
      setDnisPorMateria({});
    }
  }, [tipoInstancia, nombreCurso]);

  const handleMateriaChange = (e) => {
    const seleccion = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );

    setMateriasSeleccionadas(seleccion);

    setDnisPorMateria((prev) => {
      const nuevo = {};
      seleccion.forEach((id) => {
        nuevo[id] = prev[id] || '';
      });
      return nuevo;
    });
  };

  const seleccionarTodasMaterias = () => {
    const todas = materiasDisponibles.map((m) => String(m.id));

    setMateriasSeleccionadas(todas);

    setDnisPorMateria((prev) => {
      const nuevo = {};
      todas.forEach((id) => {
        nuevo[id] = prev[id] || '';
      });
      return nuevo;
    });
  };

  const limpiarMateriasSeleccionadas = () => {
    setMateriasSeleccionadas([]);
    setDnisPorMateria({});
  };

  const handleDnisChange = (materiaId, value) => {
    setDnisPorMateria((prev) => ({
      ...prev,
      [materiaId]: value
    }));
  };

  const handleDnisBlur = (materiaId) => {
    setDnisPorMateria((prev) => ({
      ...prev,
      [materiaId]: textoDnisNormalizado(prev[materiaId] || '')
    }));
  };

  const handleCrear = async () => {
let materiasExclusivasJson = {};

if (tipoInstancia === 'Exclusiva') {
  materiasSeleccionadas.forEach((id) => {
    if (esFinalExclusiva) {
      materiasExclusivasJson[id] = 'final';
    } else {
      const dnis = normalizarDnis(dnisPorMateria[id] || '');
      materiasExclusivasJson[id] = dnis;
    }
  });
}
    const datos = {
      cursoId: selectedCurso,
      nombreCurso,
      nombreInstancia,
      fechaInicio,
      fechaFinal,
      estado:estadoInicialInstancia,
      escuela: escuelaSeleccionada,
      tipoInstancia,
      tipoCalificacion,
      exclusivo:
        tipoInstancia === 'Exclusiva'
          ? JSON.stringify(materiasExclusivasJson)
          : ''
    };

    let resumenHtml = `
      <strong>Curso:</strong> ${nombreCurso}<br>
      <strong>Instancia:</strong> ${nombreInstancia}<br>
      <strong>Fechas:</strong> ${fechaInicio} → ${fechaFinal}<br>
      <strong>Tipo:</strong> ${tipoInstancia}<br>
      <strong>Tipo de calificación:</strong> ${tipoCalificacion}<br>
    `;

    if (tipoInstancia === 'Exclusiva') {
      resumenHtml += '<br><strong>Materias exclusivas:</strong><br>';

      if (materiasSeleccionadas.length === 0) {
        resumenHtml += `<span style="color:red;">No seleccionaste materias.</span><br>`;
      }

      for (const id in materiasExclusivasJson) {
        const materia = materiasDisponibles.find((m) => m.id == id);
        const dnis = materiasExclusivasJson[id];

        resumenHtml += `
          <div style="margin-bottom:8px;">
            <strong>- ${materia?.nombreMateria || id}</strong>: 
            ${dnis.length > 0 ? dnis.join(', ') : '<span style="color:red;">sin DNIs</span>'}
          </div>
        `;
      }
    }

    const result = await Swal.fire({
      title: 'Confirmar envío',
      html: resumenHtml,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, crear',
      cancelButtonText: 'Cancelar',
      width: '650px'
    });

    if (result.isConfirmed) {
      try {
        await axios.post(
          'https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/creaInstancia',
          datos
        );

        Swal.fire('Éxito', 'La instancia se creó correctamente.', 'success');
        handleBorrarTodo();
      } catch (error) {
        console.error('Error creando instancia:', error);
        Swal.fire('Error', 'Hubo un problema al crear la instancia.', 'error');
      }
    }
  };

  const handleBorrarTodo = () => {
    setSelectedCurso('');
    setSelectedNombreCurso('');
    setNombreInstancia('');
    setFechaInicio('');
    setFechaFinal('');
    setEstado(true);
    setTipoInstancia('Regular');
    setTipoCalificacion('Numerica');
    setMateriasDisponibles([]);
    setMateriasSeleccionadas([]);
    setDnisPorMateria({});
    props.myID('dale');
    setFechaError('');
  };

  const isFormValid =
    selectedCurso &&
    nombreInstancia &&
    fechaInicio &&
    fechaFinal &&
    !fechaError;

  const cursosFiltrados = cursosDisponibles?.filter((curso) => {
    if (Usuario.sedeID == 1) return true;
    if (Usuario.sedeID == 2) return curso.sede === 'Rosario';
    if (Usuario.sedeID == 3) return curso.sede === 'Recreo';
    if (Usuario.sedeID == 4) return curso.sede === 'Reconquista';
    return false;
  });

  return (
    <div style={{ maxHeight: '80vh', overflowY: 'auto', padding: '10px' }}>
      {cursosDisponibles ? (
        <>
          {escuelasDisponibles.length > 1 && (
            <div className="form-group">
              <label>Seleccione escuela:</label>
              <select
                value={escuelaSeleccionada}
                onChange={(e) => setEscuelaSeleccionada(e.target.value)}
              >
                {escuelasDisponibles.map((esc) => (
                  <option key={esc} value={esc}>
                    {esc}
                  </option>
                ))}
              </select>
            </div>
          )}

          <form className="form-container">
            <div className="form-group">
              <label>Seleccione un curso:</label>
              <select value={selectedCurso} onChange={handleSelectChange}>
                <option value="" disabled>
                  -- Selecciona un curso --
                </option>

                {(cursosFiltrados || []).map((cate) => (
                  <option key={cate.id} value={cate.id}>
                    {escuelaSeleccionada === 'Todo'
                      ? `${cate.nombreCurso} (${cate.escuela})`
                      : cate.nombreCurso}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Tipo de instancia:</label>
              <select
                value={tipoInstancia}
                onChange={(e) => setTipoInstancia(e.target.value)}
              >
                <option value="Regular">Regular</option>
                <option value="Exclusiva">Exclusiva</option>
              </select>
            </div>

            <div className="form-group">
              <label>Tipo de Calificación:</label>
              <select
                value={tipoCalificacion}
                onChange={(e) => setTipoCalificacion(e.target.value)}
              >
                <option value="Numerica">Numerica</option>
                <option value="Aprobado">Aprobado</option>
                <option value="Regular">Regular</option>
              </select>
            </div>

            {tipoInstancia === 'Exclusiva' && (
              <div
                className="form-group"
                style={{
                  border: '1px solid #ddd',
                  padding: '12px',
                  borderRadius: '8px',
                  background: '#fafafa'
                }}
              >
                <label>Materias exclusivas:</label>
<label style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
  <input
    type="checkbox"
    checked={esFinalExclusiva}
    onChange={(e) => setEsFinalExclusiva(e.target.checked)}
  />
  Es final
</label>
                {materiasDisponibles.length > 0 ? (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        gap: '8px',
                        flexWrap: 'wrap',
                        marginBottom: '8px'
                      }}
                    >
                      <button
                        type="button"
                        onClick={seleccionarTodasMaterias}
                        style={{ padding: '6px 10px', cursor: 'pointer' }}
                      >
                        Seleccionar todas
                      </button>

                      <button
                        type="button"
                        onClick={limpiarMateriasSeleccionadas}
                        style={{ padding: '6px 10px', cursor: 'pointer' }}
                      >
                        Limpiar selección
                      </button>

                      <span style={{ alignSelf: 'center', fontSize: '13px' }}>
                        Seleccionadas: {materiasSeleccionadas.length} /{' '}
                        {materiasDisponibles.length}
                      </span>
                    </div>

                    <select
                      multiple
                      value={materiasSeleccionadas}
                      onChange={handleMateriaChange}
                      style={{ minHeight: '130px', width: '100%' }}
                    >
                      {materiasDisponibles.map((m) => (
                        <option key={m.id} value={String(m.id)}>
                          {m.nombreMateria}
                        </option>
                      ))}
                    </select>

                    <small style={{ display: 'block', marginTop: '6px' }}>
                      Podés seleccionar una, varias o todas las materias.
                    </small>

                    {materiasSeleccionadas.map((materiaId) => {
                      const materia = materiasDisponibles.find(
                        (m) => String(m.id) === String(materiaId)
                      );

                      const dnisArray = normalizarDnis(
                        dnisPorMateria[materiaId] || ''
                      );

                      const tieneDnis = dnisArray.length > 0;

                      return (
                        <div
                          key={materiaId}
                          style={{
                            marginTop: '14px',
                            padding: '10px',
                            border: '1px solid #e2e2e2',
                            borderRadius: '8px',
                            background: '#fff'
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              marginBottom: '6px'
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={tieneDnis}
                              readOnly
                            />

                            <strong>
                              DNIs para {materia?.nombreMateria || materiaId}
                            </strong>

                            <span style={{ fontSize: '13px', color: '#666' }}>
                              ({dnisArray.length} DNI
                              {dnisArray.length === 1 ? '' : 's'})
                            </span>
                          </div>

                          <textarea
                            rows="4"
                            style={{ width: '100%', resize: 'vertical' }}
                            value={dnisPorMateria[materiaId] || ''}
                            onChange={(e) =>
                              handleDnisChange(materiaId, e.target.value)
                            }
                            onBlur={() => handleDnisBlur(materiaId)}
                            placeholder={`Pegá DNIs separados por coma, espacio o salto de línea.
Ej:
30111222
30222333 30333444
30444555, 30555666`}
                          />

                          <small style={{ display: 'block', marginTop: '5px' }}>
                            Al salir del campo se acomodan automáticamente
                            separados por coma.
                          </small>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div style={{ color: '#777' }}>
                    Seleccioná un curso para cargar las materias.
                  </div>
                )}
              </div>
            )}

            <div className="form-group">
              <label>Nombre de Instancia:</label>
              <input
                type="text"
                value={nombreInstancia}
                onChange={(e) => setNombreInstancia(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Fecha de Inicio:</label>
              <input
                type="date"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Fecha Final:</label>
              <input
                type="date"
                value={fechaFinal}
                onChange={(e) => setFechaFinal(e.target.value)}
              />
              {fechaError && <div style={{ color: 'red' }}>{fechaError}</div>}
            </div>
<div className="form-group">
  <label>Estado de instancia:</label>
  <select value={estado} onChange={(e) => setEstadoInicialIntancia(e.target.value)}>
    <option value="Activo">Activa</option>
    <option value="Anulada">Anulada</option>
  </select>
</div>
            <div className="form-buttons">
              <button type="button" onClick={handleCrear} disabled={!isFormValid}>
                Crear
              </button>

              <button type="button" onClick={handleBorrarTodo}>
                Borrar Todo
              </button>
            </div>
          </form>
        </>
      ) : (
        'Cargando'
      )}
    </div>
  );
};

export default CreaInstancia;